import { Box, Button, Stack, useTheme } from 'ui';
import { MenuBook } from 'ui/icons';

import { LANDSCAPE_CAMERA_FOOTER_WIDTH, PORTRAIT_CAMERA_FOOTER_HEIGHT, relativeZIndex } from '../../config';
import { CaptureButton } from '../CaptureButton/CaptureButton';
import { PreviewGallery } from '../PreviewGallery/PreviewGallery';

export const CameraFooter = ({
  capture,
  captureDisabled,
  completeDisabled,
  slotProps,
  handleOpenGuide,
  handleOnComplete,
  isPortrait,
}: {
  capture: () => void;
  captureDisabled: boolean;
  completeDisabled: boolean;
  slotProps?: {
    previewGallery?: React.ComponentProps<typeof PreviewGallery>;
  };
  handleOpenGuide: () => void;
  handleOnComplete?: () => void;
  isPortrait: boolean;
}) => {
  const theme = useTheme();

  return (
    <Box
      position="fixed"
      height={isPortrait ? PORTRAIT_CAMERA_FOOTER_HEIGHT : '100%'}
      width={isPortrait ? '100%' : LANDSCAPE_CAMERA_FOOTER_WIDTH}
      bottom={0}
      right={0}
      display="flex"
      justifyContent="space-between"
      flexDirection={isPortrait ? 'column' : 'row'}
      marginTop={isPortrait ? 'auto' : undefined}
      sx={{
        backgroundColor: theme.palette.secondary.main,
      }}
    >
      <PreviewGallery
        images={slotProps?.previewGallery?.images ?? []}
        onClick={slotProps?.previewGallery?.onClick}
        isPortrait={isPortrait}
      />
      <Stack
        display="flex"
        alignItems="center"
        flexDirection={isPortrait ? 'row' : 'column-reverse'}
        justifyContent="space-between"
        padding={2}
        paddingLeft={isPortrait ? 2 : 0}
        zIndex={theme.zIndex.modal + relativeZIndex.footer}
      >
        <Button startIcon={<MenuBook />} variant="secondary" onClick={handleOpenGuide}>
          Tour
        </Button>
        <CaptureButton onClick={capture} disabled={captureDisabled} />
        <Button
          variant={completeDisabled ? 'secondary' : 'primary'}
          disabled={completeDisabled}
          onClick={handleOnComplete}
        >
          Complete
        </Button>
      </Stack>
    </Box>
  );
};
